import React from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import axios from './../../../../constants/axios';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class ExpenseInvoices extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoices: [],
         showOnlyDue: false,
      };
   }

   componentDidMount() {
      const { contactId } = this.props.params;
      axios.get('contacts/' + contactId + '/getExpenses')
         .then((res) => {
            this.setState({
               invoices: res.data.results,
               startDate: moment(res.data.startDate),
               endDate: moment(res.data.endDate),
            });
         });
   }

   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   getInvoicesDateBetween = () => {
      const { startDate, endDate } = this.state;
      const { contactId } = this.props.params;

      if (startDate && endDate) {
         axios.get(`contacts/${contactId}/getExpenses?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  invoices: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };

   showOnlyDue = (e) => {
      const value = e.target.checked;
      this.setState({
         showOnlyDue: value,
         invoices: [],
      });
      if (value === true) {
         const { contactId } = this.props.params;
         axios.get(`contacts/${contactId}/getExpensesDue`)
            .then((res) => {
               this.setState({
                  invoices: res.data,
               });
            });
      } else {
         this.getInvoicesDateBetween();
      }
   };

   render() {
      const { invoices, showOnlyDue } = this.state;
      const getTotalDue = function () {
         if (invoices.length <= 0) {
            return 0;
         } else {
            return invoices.reduce((sum, i) => sum + i.due, 0);
         }
      };
      return (
         <div className="ExpenseInvoices" >
            <h1 >Customer Purchase Invoices</h1 >
            <Row >
               <Col md={6} >
                  {showOnlyDue === false &&
                  <div >
                     <DatePicker
                        dateFormat="DD-MM-YYYY"
                        selected={this.state.startDate}
                        placeholderText="Select Start Date"
                        onChange={this.handleStartDateChange} />
                     <DatePicker
                        dateFormat="DD-MM-YYYY"
                        selected={this.state.endDate}
                        placeholderText="Select End Date"
                        onChange={this.handleEndDateChange} />
                     <Button onClick={() => this.getInvoicesDateBetween()} >Get Invoices</Button >
                  </div >
                  }
               </Col >
               <Col md={6} >
                  <input type="checkbox" id="showOnlyDue" name="showOnlyDue" checked={this.state.showOnlyDue}
                         onChange={(e) => this.showOnlyDue(e)} />
                  <label htmlFor="showOnlyDue" >Show Only Due</label >
               </Col >
            </Row >
            <Table >
               <thead >
               <tr >
                  <th >#inv Id</th >
                  <th >Billed</th >
                  <th >Paid</th >
                  <th >Due</th >
                  <th >CS</th >
                  <th >Inv Created</th >
                  <th >##</th >
               </tr >
               </thead >
               <tbody >
               {invoices.map((inv) => (
                  <tr key={inv.id} >
                     <td >{inv.id}</td >
                     <td >{inv.total_amount}</td >
                     <td >{inv.paid_amount}</td >
                     <td >{inv.due}</td >
                     <td >{inv.cs}</td >
                     <td >{moment(inv.created_at).format('DD/MM/YYYY h:mm a')}</td >
                     <td >
                        <Link target="_blank" to={`/expense/expenseInvoiceDetail/${inv.id}`} >Details</Link >
                     </td >
                  </tr >
               ))}
               <tr >
                  <td />
                  <td />
                  <td >Totals:</td >
                  <td >{getTotalDue().toFixed(3)}</td >
                  <td className="lastCol" />
               </tr >
               </tbody >
            </Table >
         </div >
      );
   }
}

ExpenseInvoices.propTypes = {
   params: React.PropTypes.object,
};


export default ExpenseInvoices;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactInvoice/ExpensesInvoices.js
 **/